import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6ace25bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chart-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_bar_chart = _resolveComponent("bar-chart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.filtering,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filtering) = $event)),
              label: "Filter Words"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.showStudentTopWords,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showStudentTopWords) = $event)),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showTeacherTopWords = false)),
              label: "Show Student Top 10 Words"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.showTeacherTopWords,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showTeacherTopWords) = $event)),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showStudentTopWords = false)),
              label: "Show Teacher Top 10 Words"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_bar_chart, {
        data: _ctx.chartData,
        options: _ctx.chartOptions
      }, null, 8, ["data", "options"])
    ])
  ], 64))
}